<script>
export default {
  props: {
    years: {
      type: Array,
      default: () => ([]),
    },
  },
  data () {
    return {
      year: '',
      error: null,
    };
  },
  methods: {
    handleCloseAdd () {
      this.$emit('close');
    },
    handleInput (val) {
      this.year = Number(val);
    },
    handleAdd (e) {
      e.preventDefault();

      if (this.years.includes(this.year)) {
        this.error = 'Указанный год уже существует';
        return false;
      }

      this.$emit('add', this.year);
    },
  },
  render () {
    const { error, $style } = this;

    return (
      <u-modal
        width="210"
        onClose={this.handleCloseAdd}
      >
        <form
          class={$style.form}
          onSubmit={this.handleAdd}
        >
          <div class={$style.formInput}>
            <u-input
              value={this.year}
              onInput={this.handleInput}
              error={Boolean(error)}
              placeholder="2020"
            />
          </div>

          {error && (
            <div class={$style.formError}>
              {error}
            </div>
          )}

          <u-btn
            class={$style.formSubmission}
            type="submit"
          >
            Добавить
          </u-btn>
        </form>
      </u-modal>
    );
  },
};
</script>

<style lang="scss" module>
@import '@/theme/include.scss';

.form {
  align-self: center;
  display: flex;
  flex-direction: column;

  &Error {
    color: $color-red-darkest;
    font-size: 14px;
    margin: 10px 0;
    padding-left: 10px;
    text-align: center;
  }

  &Input {
    display: block;
    margin: 0 auto 10px;
  }

  &Submission {
    display: block;
    margin: 10px auto 0;
  }
}
</style>
